module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("1lWLa"))).then(() => parcelRequire('1JSyC'));